<!--Navbar-->
<mdb-navbar SideClass="navbar navbar-expand-lg navbar-dark unique-color navbar-main" [containerInside]="false">

  <!-- Navbar brand -->
  <div class="col-lg-12">
    <mdb-navbar-brand><a class="navbar-brand"><img class="logocls" src="../../assets/images/med-logo.png" /></a></mdb-navbar-brand>

    <div class="right-profile-section">
      <div class="profile-section">
        <h3>{{profile?.displayName}}</h3>
      </div>
      <div class="profile-section pull-right width15">
          <a (click)="exit()" style="cursor: pointer;" ><img src="../../assets/images/exit.svg" /><br/>
          <h5>Exit</h5></a>
      </div>
    </div>

  </div>
  <!-- Collapsible content -->
  <div class="col-lg-12">
  <links>

    <!-- Links -->
    <ul class="navbar-nav mr-auto navbar-links">
      <li class="nav-item">
          <a href="#" routerLink="../Iamportal" *ngIf="administrationNavigation" [routerLinkActive]="['is-active']">Administration</a>
      </li>
      
      <li class="nav-item">
        <a href="#" routerLink="../Management-Configuration" *ngIf="configurationNavigation" [routerLinkActive]="['is-active']">Management Configuration </a>
      </li>

      <li class="nav-item">
        <a href="#" routerLink="../Assignment-Arena" *ngIf="assignmentArenaNavigation" [routerLinkActive]="['is-active']">Assignment Arena</a>
      </li>

      <li class="nav-item">
        <a href="#" routerLink="../Provider-Availability" *ngIf="providerAvailabilityNavigation" [routerLinkActive]="['is-active']">Provider Availability</a>
      </li>
    </ul>
    <!-- Links -->

  </links>
</div>
</mdb-navbar>
<!--/.Navbar-->